export const isRedirectError = error => {
  if (
    error.config.method !== 'get' ||
    error.config.url.startsWith('/people-experience') ||
    error.config.url.startsWith('/time-tracking/report')
  ) {
    return false;
  }

  return (
    error.response?.status === 403 ||
    error.response?.status === 404 ||
    (error.response?.status === 400 &&
      error.response?.data?.message === 'Invalid id format')
  );
};
